import { useCallback, useEffect, useRef } from "react";

export default function useScrollToBottom(
  callback: (show: boolean) => void,
  shouldScrollToBottom?: boolean,
  chatId?: string
) {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const lastMessageRef = useRef<HTMLDivElement | null>(null);

  const toggleScrollBottomIcon = useCallback(() => {
    const container = containerRef.current;
    if (!container) return;

    const { scrollTop, scrollHeight, clientHeight } = container;
    const isScrolledBottom = scrollHeight - scrollTop - 150 > clientHeight;

    callback(isScrolledBottom);
  }, [callback]);

  useEffect(() => {
    const behavior = shouldScrollToBottom ? "smooth" : "auto";
    const container = containerRef.current;

    if (container) {
      container.scrollTo({
        top: container.scrollHeight,
        behavior,
      });
    }

    if (lastMessageRef.current) {
      lastMessageRef.current.scrollIntoView({ behavior });
    }
  }, [chatId, shouldScrollToBottom]);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    container.addEventListener("scroll", toggleScrollBottomIcon);

    return () => container.removeEventListener("scroll", toggleScrollBottomIcon);
  }, [toggleScrollBottomIcon]);

  return { containerRef, lastMessageRef };
}
